module.exports = __webpack_public_path__ + "8944f47a85744f644e25f36c99693391.svg";